import React from 'react';
import { Route } from 'react-router-dom';
import ForwardFees from '@/pages/fees/ForwardFees';
import PaymentHistory from '@/pages/fees/PaymentHistory';
import FeesReport from '@/pages/fees/FeesReport';
import StudentLedger from '@/pages/fees/StudentLedger';
import FeeReminders from '@/pages/fees/FeeReminders';
import DueFees from '@/pages/fees/DueFees';
import DueFeesReport from '@/pages/fees/DueFeesReport';
import DiscountReport from '@/pages/fees/DiscountReport';
import ScholarshipReport from '@/pages/fees/ScholarshipReport';
import CollectionDayBook from '@/pages/fees/CollectionDayBook';
import FeeForwardReport from '@/pages/fees/FeeForwardReport';
import ClearanceCertificate from '@/pages/fees/ClearanceCertificate';
import FeeSetting from '@/pages/fees/FeeSetting';
import FeeSettingReport from '@/pages/fees/FeeSettingReport';
import PayFee from '@/pages/fees/PayFee';
import OtherFeeMaster from '@/pages/fees/OtherFeeMaster';
import PayOtherFee from '@/pages/fees/PayOtherFee';
import CollectOtherFee from '@/pages/fees/CollectOtherFee';
import PayOtherFeeReport from '@/pages/fees/PayOtherFeeReport';
import FeeInstallmentSetting from '@/pages/fees/FeeInstallmentSetting';
import FeeInstallmentReport from '@/pages/fees/FeeInstallmentReport';
import StudentFeePayment from '@/pages/fees/StudentFeePayment';
import InstallmentPayment from '@/pages/fees/InstallmentPayment';
import AssignOtherFees from '@/pages/fees/AssignOtherFees';
import PayCautionMoney from '@/pages/fees/PayCautionMoney';
import RefundCautionMoney from '@/pages/fees/RefundCautionMoney';
import CautionMoneyReport from '@/pages/fees/CautionMoneyReport';
import CautionMoneyDue from '@/pages/fees/CautionMoneyDue';
import PaymentLinks from '@/pages/fees/PaymentLinks';

export const feesRoutes = (
  <React.Fragment>
    <Route path="fees/fee-setting" element={<FeeSetting />} />
    <Route path="fees/installment-setting" element={<FeeInstallmentSetting />} />
    <Route path="fees/installment-report" element={<FeeInstallmentReport />} />
    <Route path="fees/fee-setting-report" element={<FeeSettingReport />} />
    <Route path="fees/pay-fee" element={<PayFee />} />
    <Route path="fees/student-fee-payment" element={<StudentFeePayment />} />
    <Route path="fees/installment-payment" element={<InstallmentPayment />} />
    <Route path="fees/other-fee-master" element={<OtherFeeMaster />} />
    <Route path="fees/assign-other-fees" element={<AssignOtherFees />} />
    <Route path="fees/pay-other-fee" element={<PayOtherFee />} />
    <Route path="fees/collect-other-fee" element={<CollectOtherFee />} />
    <Route path="fees/pay-other-fee-report" element={<PayOtherFeeReport />} />
    <Route path="fees/forward" element={<ForwardFees />} />
    <Route path="fees/payment-history" element={<PaymentHistory />} />
    <Route path="fees/report" element={<FeesReport />} />
    <Route path="fees/student-ledger" element={<StudentLedger />} />
    <Route path="fees/reminders" element={<FeeReminders />} />
    <Route path="fees/due" element={<DueFees />} />
    <Route path="fees/due-report" element={<DueFeesReport />} />
    <Route path="fees/discount-report" element={<DiscountReport />} />
    <Route path="fees/scholarship-report" element={<ScholarshipReport />} />
    <Route path="fees/collection-daybook" element={<CollectionDayBook />} />
    <Route path="fees/forward-report" element={<FeeForwardReport />} />
    <Route path="fees/clearance-certificate" element={<ClearanceCertificate />} />
    <Route path="fees/caution-money/pay" element={<PayCautionMoney />} />
    <Route path="fees/caution-money/refund" element={<RefundCautionMoney />} />
    <Route path="fees/caution-money/report" element={<CautionMoneyReport />} />
    <Route path="fees/caution-money/due" element={<CautionMoneyDue />} />
    <Route path="fees/payment-links" element={<PaymentLinks />} />
  </React.Fragment>
);
